import React, { Component } from 'react';
import PropTypes from 'prop-types';

/*
 * Component that shows a field containing International Phonetic Alphabet
 */

class IpaField extends Component {

  render() {
    const ipaFont = {
      fontFamily: 'Voces, sans-serif'
    };
    return (
      <div className="ui column">
        <div className="ui fluid icon input"
          data-tooltip="Pronunciation in International Phonetic Alphabet">

          <input 
            readOnly 
            style={ipaFont}
            disabled={!!!this.props.ipa}
            value={'[ '+this.props.ipa.split(' ').join('')+' ]'}
          />

        </div>
      </div>
    );
  }
}

IpaField.propTypes = {
  ipa: PropTypes.string.isRequired
};

export default IpaField;





// WEBPACK FOOTER //
// ./src/IpaField.js